import { authClient } from "@/lib/auth-clients";

export async function sessionEmployeeId(): Promise<string | null> {
  try {
    const { data } = await authClient.getSession();
    return (data as { employeeId?: string | null } | null)?.employeeId ?? null;
  } catch {
    return null;
  }
}
